// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPicker.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Color Picker component
 */
!(function() {

  var React = require('react');
  var classnames = require('classnames');

  var FloatAffixed = require('./Izenda.FloatAffixed');
  var ColorDialog = require('./ColorDialog/Izenda.ColorDialog');
  var connect = require('share/enhancers/Izenda.Connect');

  var ColorPicker = React.createClass({

    propsType: {
      color: React.PropTypes.String,
      iconName: React.PropTypes.String,
      onChange: React.PropTypes.func,
      isHighlightControl: React.PropTypes.bool,
      title: React.PropTypes.String
    },

    getInitialState: function() {
      var props = this.props;
      return {
        color: props.color || props.value || props.loadValue || props.defaultColor,
        isOpen: false
      }
    },

    componentWillReceiveProps: function(nextProps) {
      this.setState({
        color: nextProps.color || nextProps.value || nextProps.defaultColor
      });
    },
    
    handleShowColorPicker: function(event) {
      if (this.props.disabled) {
        return;
      }

      this.setState({ isOpen: !this.state.isOpen });
    },

    handleAccept: function(newColor) {
      this.setState({color: newColor});
      this.hideColorPicker();

      this.props.onChange && this.props.onChange(newColor);
    },

    hideColorPicker: function() {
      this.setState({ isOpen: false });
    },

    render: function() {
      var props = this.props;

      var divStyle = props.disabled ? null : { background: this.state.color };
      var pickerStyle = props.isHighlightControl ? { backgroundColor: this.state.color } : null;

      var fullSize = !props.iconName;
      var pickerClasses = classnames(props.className, {
        'color-picker': true,
        'full-size-picker': fullSize
      });

      var indicatorClasses = classnames({
        'color-indicator': true,
        'full-size-indicator': fullSize
      });

      return (
        <div
          ref='colorPicker'
          style={pickerStyle}
          title={props.title}
          className={pickerClasses}
          onMouseDown={this.handleShowColorPicker}
        >
          <a title={props.title}>
            {!fullSize
              ? <span className={this.props.iconName} />
              : null
            }
            {props.hadSetting && (<div className='u_floatRight u-posRelative'>
                                      <i className='icon-ok u_smallIcon u-hadSetting u-colorWhite u-bgGreen' />
                                  </div>)}
            <div className={indicatorClasses} style={divStyle}></div>

            {this.state.isOpen &&
              <FloatAffixed
                autoWidth
                minWidth={515}
                anchor={this.refs.colorPicker}
                onClickOutside={this.hideColorPicker}
              >
                <ColorDialog
                  color={this.state.color}
                  onAccept={this.handleAccept}
                  onCancel={this.hideColorPicker} />
              </FloatAffixed>
            }
          </a>
        </div>
      );
    }
  });

  module.exports = connect()(ColorPicker);
}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.ColorPicker.jsx